<template>
    <section class="barocare-conci-intro" id="barocare-conci-intro">
        <div class="intro-cont">
            <div class="bg-area">
                <img src="../../assets/pc_barocare_conci/bg-intro.png" alt="">
            </div>
            <div class="barocare-conci-container-lg">
                <div class="title-area" v-intersect>
                    <h2 class="text-xl">솔닥 컨시어지는<br>한국1형당뇨병환우회와 함께합니다</h2>
                    <p>
                    당뇨 환자의 의료접근성을 제고하는 한편,<br>
                    1형 당뇨에 대한 사회적 분위기와 인식을 개선하기 위한<br>
                    노력에 동참할 것을 약속드립니다
                    </p>

                    <div class="logo-area" v-intersect>
                        <span class="logo">
                            <img src="../../assets/pc_barocare_conci/img-logo-primary.png"  alt="">
                        </span>
                        <span class="cross"></span>
                        <span class="logo type2">
                            <img src="../../assets/pc_barocare_conci/img-logo-type1.png" alt="">
                        </span>
                    </div> 
                </div>
            </div>
        </div>
        <div class="card-cont" >
            <div class="barocare-conci-container-lg">
                <div class="title-area" v-intersect>
                    <h2 class="text-xl">
                    1등 비대면진료 솔닥이 만든
                    <br>당뇨인 맞춤 서비스
                    </h2>
                    <p>
                    50만 회원이 믿고 사용하는<br>
                    비대면진료 1위 솔닥이 <strong>500만 당뇨인을 위한</strong><br>
                    <strong>새로운 서비스</strong>를 선보입니다
                    </p>           
                </div>
                <div class="bot-area" v-intersect>
                    <div class="card-area">
                        <div class="card type1">
                            <img src="../../assets/pc_barocare_conci/img-service-card-1.png"    alt="">
                        </div>
                        <div class="card type2">
                            <img src="../../assets/pc_barocare_conci/img-service-card-2.png"    alt="">
                        </div>
                        <div class="card type3">
                            <img src="../../assets/pc_barocare_conci/img-service-card-3.png"    alt="">
                        </div>
                    </div>
                    <ul class="subtext-area">
                        <li><span>*</span>2024년 한경비즈니스 주최 소비자만족지수 비대면진료 부문   1위</li>
                        <li><span>**</span>2023년 4차 산업혁명 파워코리아 대전 보건복지부 장관상    수상</li>
                    </ul>    
                </div>
            </div>
        </div>
        <div class="payment-cont" >
            <div class="barocare-conci-container-lg" >
                <div class="title-area" v-intersect>
                    <div class="title-left">
                        <span class="text-sub">복잡한 청구 절차 ZERO</span>
                        <h2 class="text-xl"> 
                        물품 구매 단계부터
                        <br>본인 부담금만 결제하세요
                        </h2>
                    </div>
                    <div class="title-right">
                        <router-link to="/barocarenew/sub2" class="btn-go">어떻게 가능한가요<i class="ico-arrow-primary"></i></router-link>
                    </div>
                </div>
                <div class="box-top" v-intersect>
                        <span class="box-header">
                            <span>|</span>  일반적인 절차
                        </span>
                        <ol class="box-cont">
                            <li>진료 가능한 <br> 병원 찾기</li>
                            <li>병원 진료<span class="text-sub">병원 방문 및 대기</span></li>
                            <li>재고 찾기</li>
                            <li>물품 구매<span class="text-sub">본인부담금 + 지원금 전액선결제</span></li>
                            <li>서류 준비<span class="text-sub">거래명세서, 영수증 등 약7종</span></li>
                            <li>환급 신청<span class="text-sub">약 2~3주 소요</span></li>
                            <li>환급 완료 </li>
                        </ol>
                </div>
                <div class="box-bottom" v-intersect>
                        <div class="box-header">
                            <i class="ico-rocket"></i>
                            원스톱 위임청구
                        </div>
                        <ul class="box-cont">
                            <li>
                                <i class="ico-nonface"></i>
                                <p>병원 방문 없는<br>전화진료</p>
                            </li>
                            <li>
                                <i class="ico-truck"></i>
                                <p>물품 구매 완료<br><span class="text-sub">본인부담금만 결제</span></p>
                            </li>
                        </ul>
                </div>                    
            </div>
        </div>
        <div class="nonface-cont" >
            <div class="barocare-conci-container-lg" >
                <div class="title-area" v-intersect>
                    <div class="title-left">
                        <span class="text-sub">병원에 직접 가지 않아도</span>
                        <h2 class="text-xl"> 
                        전화로 진료보고
                        <br>처방전은 카카오톡으로
                        </h2>
                    </div>
                    <div class="title-right">
                        <router-link to="/barocarenew/sub3" class="btn-go">어떻게 이용하나요<i class="ico-arrow-primary"></i></router-link>
                    </div>
                </div>
                <div class="box-lg" v-intersect>
                    <img src="../../assets/pc_barocare_conci/img-nonface.jpg" alt="원하는 시간 진료 예약, 의사선생님과 전화 진료">    
                </div>      
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'BarocareConciIntro',
    directives: {
        intersect: {
            // 요소가 DOM에 삽입될 때 호출됩니다.
            inserted(el) {
                const options = {
                    root: null, // 뷰포트를 기본값으로 설정
                    rootMargin: '0px', // 뷰포트의 마진은 0
                    threshold: 0.1 // 10%가 보일 때 콜백이 실행
                };
                const callback = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            el.classList.add('visible');
                        } else {
                            el.classList.remove('visible');
                        }
                    });
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(el); // 해당 요소를 관찰 시작
            }
        }
    },
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_conci/BarocareConciIntro.vue